import { ErrorBoundaryFallbackComponent } from 'sierra-client/error/strategic-error-boundary'
import { ErrorCard } from 'sierra-client/features/skills/components/error/error-card'

export const widgetErrorBoundaryComponent: () => ErrorBoundaryFallbackComponent = () => {
  return () => <ErrorCard />
}
